import { CancelButton, SaveButton } from '@core/components/Buttons';
import { FormDialogContent, SimpleDialog } from "@core/components/Dialog";
import { cancelarAlert } from 'app/services/alerts';
import { FormikProvider, useFormik } from 'formik';
import React, { useContext } from 'react';
import { ServicoContext } from '../../ServicoContext';
import { servicoModais } from '../modal/servicoModais';
import ServicoBuscaAvancadaForm from './ServicoBuscaAvancadaForm';

const ServicoBuscaAvancadaModal = ({ fetchServicos }) => {
  const [modal, setModal] = useContext(ServicoContext).modal;
  const [filtroAvancado, setFiltroAvancado] = useContext(ServicoContext).filtroAvancado;
  const [search] = useContext(ServicoContext).search;
  const [size] = useContext(ServicoContext).size;
  const [sort] = useContext(ServicoContext).sort;

  const handleCancelar = ( ) => {
    if (formik.dirty){
      cancelarAlert({
        confirmar: () => {
          formik.resetForm(formik.initialValues)
          setModal('')
        }
      })
    } else {
      setModal('');
    }
  }

  const handleSubmit = (values) => {
    
    const filtroAvancado = {
      ...values,
      dataInativo: values?.dataInativo === "TRUE" ? true 
                 : values?.dataInativo === "FALSE" ? false : null
    }

    setFiltroAvancado(filtroAvancado);
    fetchServicos({ q: search, filtroAvancado, size, sort });
    setModal('');
  }

  const formik = useFormik({
    initialValues: {
      descricao: filtroAvancado.descricao,
      codigo: filtroAvancado.codigo,
      dataInativo: filtroAvancado.dataInativo,
      promocao: filtroAvancado.promocao,
    },
    onSubmit: handleSubmit
  })

  return (
    <SimpleDialog open={modal === servicoModais.buscaAvancada} onClose={handleCancelar}>
      <FormikProvider value={formik}>
        <FormDialogContent
          onSubmit={formik.handleSubmit}
          header={{
            title: 'Busca Avançada',
            toolbar: (
              <>
                <CancelButton title="cancelar" type="button" 
                onClick={handleCancelar}
                >
                  Cancelar
                </CancelButton>
                <SaveButton color="buttonSave" type="submit">
                  Aplicar
                </SaveButton>
              </>
            ),
          }}
          content={<ServicoBuscaAvancadaForm/>}
          contentStyle={{ padding: 0 }}
        />
      </FormikProvider>
    </SimpleDialog>
  )
}

export default ServicoBuscaAvancadaModal;